import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'flo-special-rankings',
  templateUrl: './special-rankings.component.html',
  styleUrls: ['./special-rankings.component.scss']
})
export class SpecialRankingsComponent implements OnInit {
  constructor(private readonly activatedRoute: ActivatedRoute) {
    console.log('Activated Route URL Segments:', this.activatedRoute.snapshot.url)
  }
  ngOnInit(): void {
    console.log('Special Rankings Component Initialized', this.activatedRoute.snapshot.url)
  }
}
